import * as React from 'react'

import { Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { useSchedule } from 'modules/shift_management/hooks/useSchedule'

const ConflictsTooltip = ({ children }: React.PropsWithChildren) => {
  const [{ conflictsCount }] = useSchedule()
  const [tooltipOpen, toggleTooltip] = useToggle()

  /**
   * We show the tooltip only when the button is disabled because of conflicts
   * If the button is disabled because there are no drafts, we don't show it.
   */
  const showTooltip = conflictsCount !== 0 && tooltipOpen

  return (
    <Tooltip.Alt
      attachment="top center"
      targetAttachment="bottom center"
      open={showTooltip}
      toggle={toggleTooltip}
      label={i18n.t('shift_management.publish.disabled_tooltip')}
    >
      {children}
    </Tooltip.Alt>
  )
}

export default ConflictsTooltip
